import { useContext, useMemo } from 'react'
import { useForm } from 'react-hook-form'
import { useRouter } from 'next/router'
import Link from 'next/link'
import Image from 'next/image'
import styles from './styles.module.scss'
import { FormHookProvider } from '@/components/moleculas'
import { InputText } from '@/components/moleculas/InputText'
import { InputPassword } from '@/components/moleculas/InputPassword'
import { Dropdown } from '@/components/moleculas/Dropdown'
import { RadioButton } from '@/components/moleculas/RadioButton'
import { Button } from '@/components/atoms'
import logoBasys from '@/img/logoBlack.png'
import { RegisterContext } from '@/context'
import { AuthContext } from '@/context/AuthContext'

export default function FormRegister () {
  const { onSubmit, isLoading } = useContext(AuthContext)
  const { selects, loading, placeholder, onChange } = useContext(RegisterContext)
  const methods = useForm()
  const { getValues } = methods
  const router = useRouter()

  const inputTextEmail = useMemo(
    () => ({
      name: 'email',
      type: 'email',
      placeholder: 'Ingrese correo',
      label: 'Correo',
      icon: 'icon i-user',
      variant: 'primary',
      height: '45px',
      rules: {
        required: 'El correo electrónico es requerido.',
        pattern: {
          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
          message: 'Ingresa un correo electrónico válido.'
        }
      },
      className: 'input-bold'
    }), [])

  const inputPassword = useMemo(() => ({
    name: 'password',
    placeholder: 'Ingrese contraseña',
    label: 'Contraseña',
    feedback: false,
    toggleMask: true,
    rules: {
      required: 'La contraseña es requerida.',
      minLength: {
        value: 6,
        message: 'La contraseña debe tener al menos 6 caracteres.'
      }
    },
    className: 'input-bold password-icon'
  }), [])

  const inputPasswordConfirmation = useMemo(() => ({
    name: 'password_confirmation',
    placeholder: 'Ingrese contraseña',
    label: 'Confirmar contraseña',
    feedback: false,
    toggleMask: true,
    className: 'input-bold password-icon',
    rules: {
      required: 'La confirmación de contraseña es requerida.',
      validate: (value) => value === getValues('password') || 'Las contraseñas no coinciden.'
    }
  }), [getValues])

  const dropdownCountry = useMemo(() => ({
    name: 'country',
    onChange: onChange.onCountryChange,
    options: selects.countries,
    // options: counties,
    optionLabel: 'text',
    placeholder: '- Seleccione opción -',
    label: 'País',
    variant: 'primary',
    height: '45px',
    filter: true,
    // loading: loading.countries,
    rules: {
      required: 'El país es requerido.'
    }
  }), [loading.countries, onChange.onCountryChange, selects.countries])
  // }), [])

  const inputPhonenumber = useMemo(() => ({
    name: 'phone_number',
    type: 'number',
    placeholder: placeholder.phonenumber,
    label: 'Teléfono (Whatsapp)',
    variant: 'primary',
    height: '45px',
    rules: {
      required: 'El teléfono es requerido.',
      pattern: {
        value: /^\d{10}$/,
        message: 'El teléfono debe tener 10 dígitos.'
      }
    }
  }), [placeholder.phonenumber])

  const inputTradeName = useMemo(() => ({
    name: 'trade_name',
    // type: 'number',
    placeholder: placeholder.trade,
    label: 'Nombre del negocio',
    variant: 'primary',
    height: '45px',
    rules: {
      required: 'El nombre es requerido.'
    }
  }), [placeholder.tradeName])

  const radioButtonTerms = useMemo(() => ({
    name: 'terms',
    value: 'terms',
    label: <>Acepto los<Link href='/terms-conditions' target="_blank">Términos de uso</Link> y <Link href='/privacy-policy' target="_blank">Política de privacidad</Link></>,
    variant: 'secondary',
    rules: { required: true }
  }), [])

  return (
    <div className={styles.section}>
      <div className={styles.section_container}>
        <div className={styles.section_header}>
          <Image
            src={logoBasys}
            width={320}
            height={90}
            alt='basys'
            loading='lazy'
          />
          <div>
            Registro
          </div>
        </div>
        <FormHookProvider onSubmit={onSubmit.handleRegisterSubmit} method='POST' methods={methods}>
          <div className={styles.form}>
            <div className={styles.form_input}>
              <InputText {...inputTextEmail} />
            </div>
            <div className={styles.form_input}>
              <InputPassword {...inputPassword} />
            </div>
            <div className={styles.form_input}>
              <InputPassword {...inputPasswordConfirmation} />
            </div>
            <div className={styles.form_input}>
              <Dropdown {...dropdownCountry} />
            </div>
            <div className={styles.form_input}>
              <InputText {...inputPhonenumber} />
            </div>
            <div className={styles.form_input}>
              <InputText {...inputTradeName} />
            </div>
            <div className={styles.form_terms}>
              <RadioButton {...radioButtonTerms} />
            </div>
            <div className={styles.form_button}>
              <Button
                label='Registrarme'
                type='submit'
                rounded
                className='btn-yellow btn-md'
                disabled={isLoading}
              />
            </div>
          </div>
        </FormHookProvider>
        <div className={styles.section_footer}>
          <div>¿Ya tienes cuenta?</div>
          <div>
            <Button
              label='Iniciar sesión'
              onClick={() => router.push('/login')}
              rounded
              className='btn-yellow btn-md'
            />
          </div>
        </div>
      </div>
    </div>
  )
}
